import './wdyr';

import { ThemeProvider } from '@mui/material/styles';
import { ConnectedRouter as Router } from 'connected-react-router';
import * as React from 'react';
import ReactDom from 'react-dom';
import { Provider, useSelector } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';

import './index.scss';

import { useMemo } from 'react';
import { FabProvider } from './contexts/FabContext';
import { FooterProvider } from './contexts/FooterContext';
import Routes from './Routes';
import { history, persistor, store } from './store';
import { selectAccentColor } from './store/selectors/init';
import { createDynamicTheme } from './theme/themeConfig';

const DynamicThemeWrapper = ({ children }: { children: React.ReactNode }) => {
  const accentColor = useSelector(selectAccentColor);

  const theme = useMemo(() => {
    return createDynamicTheme(accentColor ? { primaryColor: accentColor, buttonColor: accentColor } : {});
  }, [accentColor]);

  return <ThemeProvider theme={theme}>{children}</ThemeProvider>;
};

const container = document.getElementById('root');
// Downgraded to React v17 because of random Safari issues
// that apparently are related to batch updates in v18
// Open issue: https://github.com/facebook/react/issues/26713
// const root = createRoot(container!);

ReactDom.render(
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <DynamicThemeWrapper>
        <FabProvider>
          <FooterProvider>
            <Router history={history}>
              {/*<React.StrictMode>*/}
              <Routes />
              {/*</React.StrictMode>*/}
            </Router>
          </FooterProvider>
        </FabProvider>
      </DynamicThemeWrapper>
    </PersistGate>
  </Provider>,
  container!,
);
